module.exports = __webpack_public_path__ + "static/media/2.de10b03.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/2.wav
// module id = Qz34
// module chunks = 0